export type TypeMergeFileDataEntry = {
    name: string;
    relativePath?: string;
};

// ----------------------------------------------------------------------------

function mergeFileData<T extends TypeMergeFileDataEntry>(existingData: T[], newEntries: T[]): T[] {
    const existingKeys = new Set(existingData.map((file): any => file.relativePath ?? file.name));

    for (const entry of newEntries) {
        const key = entry.relativePath ?? entry.name;

        if (!existingKeys.has(key)) {
            existingData.push(entry);
            existingKeys.add(key);
        }
    }

    return existingData;
}

// ----------------------------------------------------------------------------

export default mergeFileData;
